module.exports = new __parcel__URL__("issue-chart-app-skeleton.tpl.268ca1ab.svg").toString();